import { DocumentsTableColumnModel } from '../../../shared/components';
import { TableAlignEnum } from '../../../shared/components';
import { UserListTabs } from './enums/user-list-tabs.enum';

export function getConfigColumns(activeStatus: UserListTabs): DocumentsTableColumnModel[] {
  const columns: (DocumentsTableColumnModel & { showCondition?: boolean })[] = [
    {
      name: '#',
      prop: 'acc 1',
      width: '40px'
    },
    {
      name: 'TEAM.EMPLOYEE_ID',
      prop: 'runpleId',
      cell: 'rid',
      sortable: true,
      width: '128px',
      customizable: true
    },
    {
      name: 'COLUMN.STATUS',
      prop: 'statusValue',
      cell: 'status',
      sortable: true,
      width: '124px',
      alignment: TableAlignEnum.CENTER,
      customizable: true
    },
    {
      name: 'COLUMN.EMPLOYEE',
      prop: 'nameData',
      sortProp: 'name',
      cell: 'employee',
      sortable: true,
      width: '1fr',
      minWidth: '200px'
    },
    {
      name: 'COLUMN.DEPARTMENT',
      prop: 'department',
      sortable: true,
      width: '147px',
      customizable: true
    },
    {
      name: 'TEAM.POSITION',
      prop: 'position',
      sortable: true,
      width: '147px',
      customizable: true
    },
    {
      name: 'COLUMN.EMAIL',
      prop: 'email',
      sortable: true,
      width: '176px',
      customizable: true
    },
    {
      name: 'COLUMN.LAST_ACTIVITY',
      prop: 'lastActivity',
      cell: 'dateTime',
      sortable: true,
      width: '160px',
      customizable: true,
      showCondition: activeStatus !== UserListTabs.Inactive && activeStatus !== UserListTabs.Deleted
    },
    {
      name: 'COLUMN.DEACTIVATED',
      prop: 'deactivatedAt',
      cell: 'date',
      sortable: true,
      width: '147px',
      customizable: true,
      showCondition: activeStatus !== UserListTabs.Active && activeStatus !== UserListTabs.Deleted
    },
    {
      name: 'COLUMN.DELETED',
      prop: 'deletedAt',
      cell: 'date',
      sortable: true,
      width: '147px',
      customizable: true,
      showCondition: activeStatus !== UserListTabs.Active && activeStatus !== UserListTabs.Inactive
    },
    {
      name: null,
      prop: null,
      cell: 'open',
      width: '64px',
      sticky: 'right',
    },
  ];

  return columns.filter(col => col.showCondition === undefined || col.showCondition);
}
